import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { ClientTypes } from './actionTypes';
import {
  getClients,
  getClientsSuccess,
  getClientsFail,
  addClientsFail,
  addClientsSuccess,
  deleteClientsSuccess,
  deleteClientsFail,
  updateClientsFail,
  getBrandCustomSuccess,
  getBrandCustomFail,
  updateImageClientsFail,
  sendTestEmailSuccess,
  sendTestEmailFail,
  getBrandCustom,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';
import { updateStyleDocument } from '../../helpers/tools_helper';

export const fetchClients = async ({ data }: any) => {
  let textName = '';
  let textEmail = '';

  if (data.data) {
    textName = data.data['Search Name'];
    textEmail = data.data['Search Email'];
  }

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const queryPagination = `{
      sizePage: ${data?.pagination?.sizePerPage || 0}, 
      actualPage: ${data?.pagination?.page || 0}
    }`;

  const query = `query{
    Clients(
      filter:{
        ${textName ? `name: "${textName}"` : ''}
        ${textEmail ? `,email: "${textEmail}"` : ''}
      },
      FilterEmpresaID:{
        ${user.id ? `userId: ${user.id}` : ''}
      },
      Pagination: ${queryPagination}
    ){
    listData {
      id
      name
      email
      company
      description
      enabled
      logo
      logoSmall
      urlHome
      urlLogin
      urlFavicon
      urlLoading
      primaryColor
      secondaryColor
      primaryDarkColor
      secondaryDarkColor
      sidebarBgColor
      headerBgColor
      headerDarkBgColor
      smtpEmail
      smtpPassword
      smtpHost
      smtpPort
      smtpAccesstoken
      smtpsecure
      clientGoogleId
      clientGoogleSecret
      refreshTokenGoogle
      emailType
      lineGraphicTitle
      lineGraphicColor
      donutGraphicTitle
      donutGraphicColor
      barGraphicTitle
      barGraphicColor
      formatDate
      longDecimal
      longInteger
      timeZone
      language
      availableRequests
      countRequest
      restartDay
      restartMonth
      activeRequest
      progressRequest
      modalHeaderBackground
      modalHeaderTitle
      modalHeaderText
      isMilestoneBackground
      isMilestoneCircle
      isMilestoneText
      modalBodyBackground
      modalBodyTitle
      modalBodyText
      modalTotalBackground
      modalTotalText
      nameUserGoogle
      photoUserGoogle
    }
    CountItems
  }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  const { listData } = response.data.Clients;

  listData.map((client: any) => {
    if (client.donutGraphicColor) {
      client.donutGraphicColor = JSON.parse(client.donutGraphicColor);
    }
    if (client.barGraphicColor) {
      client.barGraphicColor = JSON.parse(client.barGraphicColor);
    }
  })
  return response.data.Clients;
};

function* getClientSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchClients, data);
    yield put(getClientsSuccess(response));
  } catch (error: any) {
    yield put(getClientsFail(error));
  }
}

//ADD CLIENT -------------------------------
export const addClientList = async ({ payload: { clientsAdd } }: any) => {
  const {
    name,
    email,
    company,
    description,
    enabled,
  } = clientsAdd;

  const query = `mutation{
    createClients(Clients: {
      name: "${name}",
      email: "${email}",
      company: ${company},
      description: "${description}",
      enabled: ${enabled},
    } ){
      id  
    }
  }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return respon.data.createClients;
};

function* addClientSaga(client: any) {
  try {
    const response: Promise<any> = yield call(addClientList, client);
    yield put(addClientsSuccess(response));
    yield put(getClients({}));
  } catch (error) {
    yield put(addClientsFail(error));
  }
}

//DELETE CLIENT -----------------------------------
export const deleteClientList = async ({ payload: { id } }: any) => {
  const path = url.API_URL;

  const query = `mutation{
    deleteClients(Clients: {
      id: ${id}
     }){
      id
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteClients;
};

function* deleteCLientSaga(id: any) {
  try {
    const response: Promise<any> = yield call(deleteClientList, id);
    yield put(deleteClientsSuccess(response));
    yield put(getClients({}));
  } catch (error) {
    yield put(deleteClientsFail(error));
  }
}

//UPDATE CLIENTS-------------------------
function* updateClientList({ payload: { client } }: any): any {
  const path = url.API_URL;

  const {
    id,
    name,
    email,
    company,
    description,
    enabled,
    logo,
    logoSmall,
    primaryColor,
    secondaryColor,
    primaryDarkColor,
    secondaryDarkColor,
    sidebarBgColor,
    headerBgColor,
    headerDarkBgColor,
    smtpEmail,
    smtpPassword,
    smtpHost,
    smtpPort,
    smtpAccesstoken,
    smtpsecure,
    clientGoogleId,
    clientGoogleSecret,
    refreshTokenGoogle,
    emailType,
    lineGraphicTitle,
    lineGraphicColor,
    donutGraphicTitle,
    donutGraphicColor,
    barGraphicTitle,
    barGraphicColor,
    formatDate,
    longDecimal,
    longInteger,
    timeZone,
    language,
    availableRequests,
    activeRequest,
    progressRequest,
    modalHeaderBackground,
    modalHeaderTitle,
    modalHeaderText,
    isMilestoneBackground,
    isMilestoneCircle,
    isMilestoneText,
    modalBodyBackground,
    modalBodyTitle,
    modalBodyText,
    modalTotalBackground,
    restartDay,
    modalTotalText,
    urlLinkBanner,
    urlImgBanner,
    nameUserGoogle,
    photoUserGoogle
  } = client.newObject;


  const query = `mutation{
    updateClients(Clients: {
      id: ${id}
      name: "${name}",
      email: "${email}",
      company: ${company},
      description: "${description}",
      enabled: ${enabled},
      logo:"${logo}",  
      logoSmall:"${logoSmall}",
      primaryColor:"${primaryColor}",
      secondaryColor:"${secondaryColor}",
      primaryDarkColor:"${primaryDarkColor}",
      secondaryDarkColor:"${secondaryDarkColor}",
      sidebarBgColor:"${sidebarBgColor}",
      headerBgColor:"${headerBgColor}",
      headerDarkBgColor:"${headerDarkBgColor}",
      smtpEmail: "${smtpEmail}",
      smtpPassword: "${smtpPassword}",
      smtpHost: "${smtpHost}",
      smtpPort: "${smtpPort}",
      smtpAccesstoken: "${smtpAccesstoken}",
      smtpsecure: ${smtpsecure ?? false},

      clientGoogleId: "${clientGoogleId}",
      clientGoogleSecret: "${clientGoogleSecret}",
      refreshTokenGoogle: "${refreshTokenGoogle}",
      nameUserGoogle: "${nameUserGoogle}",
      photoUserGoogle: "${photoUserGoogle}",

      emailType: "${emailType}",
      lineGraphicTitle:"${lineGraphicTitle}",
      lineGraphicColor:"${lineGraphicColor}",
      donutGraphicTitle:"${donutGraphicTitle}",
      donutGraphicColor:${donutGraphicColor
      ? `"${JSON.stringify(donutGraphicColor).replace(/"/g, '\\"')}"`
      : 'null'
    },
      barGraphicTitle:"${barGraphicTitle}",
      barGraphicColor:${barGraphicColor
      ? `"${JSON.stringify(barGraphicColor).replace(/"/g, '\\"')}"`
      : 'null'
    },
      formatDate:"${formatDate}",
      longDecimal: ${longDecimal},
      longInteger: ${longInteger},
      timeZone: ${timeZone ? `"${timeZone}"` : 'null'},
      ${language ? `language: "${language}",` : ''}
      availableRequests: ${availableRequests},
      restartDay: ${restartDay},
      activeRequest: ${activeRequest},
      progressRequest: ${progressRequest},
      modalHeaderBackground: "${modalHeaderBackground}",
      modalHeaderTitle: "${modalHeaderTitle}",
      modalHeaderText: "${modalHeaderText}",
      isMilestoneBackground: "${isMilestoneBackground}",
      isMilestoneCircle: "${isMilestoneCircle}",
      isMilestoneText: "${isMilestoneText}",
      modalBodyBackground: "${modalBodyBackground}",
      modalBodyTitle: "${modalBodyTitle}",
      modalBodyText: "${modalBodyText}",
      modalTotalBackground: "${modalTotalBackground}",
      modalTotalText: "${modalTotalText}",
      urlLinkBanner: "${urlLinkBanner}",
      urlImgBanner: "${urlImgBanner}"
    }){
      id
    }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);

    const response: Promise<any> = yield call(fetchClients, {
      resp,
      data: client,
    });
    yield put(getClientsSuccess(response));
    yield put(getBrandCustom())
  } catch (error) {
    yield put(updateClientsFail(error));
  }
}

export const fetchBrandCustom = async () => {
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  const query = `query {
    getClientByUserId(
      userId: ${user.id}
    ){
      id
      name
      email
      company
      description
      enabled
      logo  
      logoSmall
      urlHome
      urlLogin
      urlFavicon
      urlLoading
      primaryColor
      secondaryColor
      primaryDarkColor
      secondaryDarkColor
      sidebarBgColor
      headerBgColor
      headerDarkBgColor
      smtpEmail
      smtpPassword
      smtpHost
      smtpPort
      smtpsecure
      smtpAccesstoken
      clientGoogleId
      clientGoogleSecret
      refreshTokenGoogle
      emailType
      lineGraphicTitle
      lineGraphicColor
      donutGraphicTitle
      donutGraphicColor
      barGraphicTitle
      barGraphicColor
      formatDate
      longDecimal
      longInteger
      timeZone
      language
      availableRequests
      countRequest
      restartDay
      restartMonth
      activeRequest
      progressRequest
      modalHeaderBackground
      modalHeaderTitle
      modalHeaderText
      isMilestoneBackground
      isMilestoneCircle
      isMilestoneText
      modalBodyBackground
      modalBodyTitle
      modalBodyText
      modalTotalBackground
      modalTotalText
      urlImgBanner
      urlLinkBanner
      nameUserGoogle
      photoUserGoogle
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  const { getClientByUserId } = response.data;

  if (getClientByUserId) {
    if (getClientByUserId.donutGraphicColor) {
      getClientByUserId.donutGraphicColor = JSON.parse(
        getClientByUserId.donutGraphicColor,
      );
    }

    if (getClientByUserId.barGraphicColor) {
      getClientByUserId.barGraphicColor = JSON.parse(
        getClientByUserId.barGraphicColor,
      );
    }
  }

  return response.data.getClientByUserId;
};

function* getBrandCustomSaga() {
  try {
    const response: Promise<any> = yield call(fetchBrandCustom);
    yield put(getBrandCustomSuccess(response));
  } catch (error) {
    yield put(getBrandCustomFail(error));
  }
}

function* updateImageClient({ payload }: any): any {
  const { file, networkId, nameField } = payload;

  try {
    const client = new ApolloClient({
      link: createUploadLink({ uri: url.API_URL }),
      cache: new InMemoryCache(),
    });

    const query = gql`
      mutation addPhotoClient(
        $file: Upload!
        $networkId: String
        $nameField: String
      ) {
        addPhotoClient(
          file: $file
          networkId: $networkId
          nameField: $nameField
        ) {
          success
          url
        }
      }
    `;

    const mutationPromise = client.mutate({
      mutation: query,
      variables: { file, networkId: String(networkId), nameField },
    });
    yield call(() => mutationPromise.then(() => { }));

    const brand = JSON.parse(localStorage.getItem('brand') || '');
    let imageBrand = (brand[
      nameField === 'logoSmall' ? 'small_logo' : nameField
    ] += `?timestamp=${Date.now()}`);
    imageBrand = imageBrand.split('?timestamp=')[0] +=
      `?timestamp=${Date.now()}`;
    brand[nameField === 'logoSmall' ? 'small_logo' : nameField] = imageBrand;

    localStorage.setItem('brand', JSON.stringify(brand));

    updateStyleDocument();
    const response: Promise<any> = yield call(fetchBrandCustom);
    yield put(getBrandCustomSuccess(response));
  } catch (error) {
    yield put(updateImageClientsFail(error));
  }
}

export const fetchSendEmailTest = async ({ payload: testEmail }: any) => {
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  const query = `query {
    sendTestEmail(
      company: "${user.EMPRESA_ID}"
      testEmail: "${testEmail}"
      ){
      success
      message      
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.sendTestEmail;
};

function* SendEmailTest(payload: any) {
  try {
    const response: Promise<any> = yield call(fetchSendEmailTest, payload);
    yield put(sendTestEmailSuccess(response));
  } catch (error) {
    yield put(sendTestEmailFail(error));
  }
}

function* clientSaga() {
  yield takeEvery(ClientTypes.GET_CLIENTS, getClientSaga);
  yield takeEvery(ClientTypes.ADD_CLIENTS, addClientSaga);
  yield takeEvery(ClientTypes.DELETE_CLIENTS, deleteCLientSaga);
  yield takeLatest(ClientTypes.UPDATE_CLIENTS, updateClientList);
  yield takeEvery(ClientTypes.GET_BRAND_CUSTOM, getBrandCustomSaga);
  yield takeEvery(ClientTypes.UPDATE_IMAGE_CLIENTS, updateImageClient);
  yield takeEvery(ClientTypes.SEND_TEST_EMAIL, SendEmailTest);
}

export default clientSaga;
